import { useEffect, useState, useCallback } from "react";
import client from "@/lib/api";

const DEFAULTS = { wiki_restricted: false };

/**
 * Fetches public site settings (feature flags). Safe for unauthenticated pages.
 * Returns { settings, loading, refresh }.
 */
export default function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const r = await client.get("/settings/site");
      setSettings({ ...DEFAULTS, ...r.data });
    } catch {
      // keep defaults on failure so the site never hard-locks itself
      setSettings(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { settings, loading, refresh };
}
